import React from 'react';
import PropTypes from 'prop-types';
import { useApolloClient, gql } from '@apollo/client';
import { Typeahead } from '@administrate/piston-ux';
import { withTranslation } from 'react-i18next';
import { extractNodes } from './pickerHelpers';

const GET_LOCATIONS = gql`
  query getLocations(
    $filters: [LocationFieldFilter!]!
    $order: LocationFieldOrder!
  ) {
    locations(filters: $filters, order: $order) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const LocationPicker = ({ t, name, multiple, onChange }) => {
  const client = useApolloClient();

  const loadOptions = async inputValue => {
    const { data } = await client.query({
      query: GET_LOCATIONS,
      variables: {
        filters: [
          {
            field: 'name',
            operation: 'like',
            value: `%${inputValue}%`,
          },
        ],
        order: {
          field: 'name',
          direction: 'asc',
        },
      },
    });

    return extractNodes(data?.locations);
  };

  return (
    <Typeahead
      name={name}
      multiple={multiple}
      label={multiple ? t('builder:locations') : t('builder:location')}
      loadOptions={loadOptions}
      formatter={location => location.name}
      staticFormatter={location => location.name}
      onChange={onChange}
    />
  );
};

LocationPicker.propTypes = {
  t: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

LocationPicker.defaultProps = {
  multiple: false,
};

export default withTranslation()(LocationPicker);
